import { render } from "./RegisterComponent.vue?vue&type=template&id=4c170c68&scoped=true"
import script from "./RegisterComponent.vue?vue&type=script&lang=js"
export * from "./RegisterComponent.vue?vue&type=script&lang=js"

import "./RegisterComponent.vue?vue&type=style&index=0&id=4c170c68&lang=css"
import "./RegisterComponent.vue?vue&type=style&index=1&id=4c170c68&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c170c68"]])

export default __exports__